/* kr-site.js — KREACT global front-end utilities (Phase 2)
   Ports the source's shared, page-agnostic behavior: scroll-reveal.
   Section-specific behavior (nav scroll state, carousels, plan picker, etc.) ships in later phases.
   Vanilla, no dependencies. Loaded with defer. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal: .kr-reveal -> .is-visible (config verbatim from /source) ---- */
  function initReveal(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.kr-reveal:not(.is-visible)');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- FAQ accordion: one item open per .kr-faq group ---- */
  function initFaq(scope) {
    (scope || document).querySelectorAll('.kr-faq').forEach(function (group) {
      if (group.dataset.krFaq) return;
      group.dataset.krFaq = '1';
      group.querySelectorAll('.kr-faq-q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.kr-faq-item');
          if (!item) return;
          var was = item.classList.contains('kr-open');
          group.querySelectorAll('.kr-faq-item.kr-open').forEach(function (el) { el.classList.remove('kr-open'); });
          if (!was) item.classList.add('kr-open');
        });
      });
    });
  }

  function init() { initReveal(document); initFaq(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-scan when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initFaq(e.target);
  });

  /* Expose for later phase scripts that inject markup dynamically */
  window.KR = window.KR || {};
  window.KR.initReveal = initReveal;
})();
